module.exports = __webpack_public_path__ + "static/media/edit_tag.9c4b30bb.svg";